import { Box, Typography } from '@mui/material';

import { DELETE_DIALOG_TITLE_SX, DELETE_DIALOG_WARNING_SX } from '../styles';

import type { DeletePlanDialogContentProps } from './types';

export default function DeletePlanDialogContent({ planLabel }: DeletePlanDialogContentProps) {
  return (
    <Box>
      <Typography sx={DELETE_DIALOG_TITLE_SX}>
        Are you sure you want to delete treatment plan {planLabel}?
      </Typography>
      <Typography sx={DELETE_DIALOG_WARNING_SX}>This action cannot be undone.</Typography>
    </Box>
  );
}
